export default {
  top_comment_list: [], // 评论置顶
  comment_list: []
}
